import { RootStateData } from '@jurnee/common/src/browser/State';
import { PartnerJSON } from '@jurnee/common/src/entities/Partner';
import { createSlice } from '@reduxjs/toolkit';
import { bootstrap } from 'store/bootstrap/bootstrap.thunks';
import { updatePartnerAddressThunk, updatePartnerThunk } from './partner.thunks';

const initialState: RootStateData<PartnerJSON | null> = {
  data: null,
  error: false,
  status: 'INITIAL'
};

const slice = createSlice({
  name: 'partner',
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder.addCase(bootstrap.fulfilled, (state, action) => {
      return {
        data: action.payload.partner,
        error: false,
        status: 'FETCHED'
      };
    });

    builder.addCase(updatePartnerThunk.fulfilled, (state, action) => {
      return {
        data: action.payload,
        error: false,
        status: 'FETCHED'
      };
    });

    builder.addCase(updatePartnerAddressThunk.fulfilled, (state, action) => {
      if (!state.data) {
        return state;
      }
      return {
        data: {
          ...state.data,
          address: action.payload
        },
        error: false,
        status: 'FETCHED'
      };
    });

  }
});

export default slice.reducer;